'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, SkeletonBar, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { validateStockStatus } from '../../../utils/stockStatusUtils';
import { MinimumQuantityText } from './minimum-quantity-text';
import './sdd-details.scss';
export type SddDetailsProps = Readonly<{
  isLoading: boolean;
  streetAddress?: string;
  availableStock: number;
  minimumCaseQty: number;
  isDoorDashAvailable: boolean;
  onOpenAddressDrawer?: () => void;
  className?: string;
  emphasizeAddress?: boolean;
}>;
export const SddDetails = t0 => {
  const $ = _c(27);
  const {
    isLoading,
    streetAddress,
    availableStock,
    minimumCaseQty,
    isDoorDashAvailable,
    onOpenAddressDrawer,
    className,
    emphasizeAddress: t1
  } = t0;
  const emphasizeAddress = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("sdd-details", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== availableStock || $[3] !== emphasizeAddress || $[4] !== isDoorDashAvailable || $[5] !== isLoading || $[6] !== minimumCaseQty || $[7] !== streetAddress) {
    t3 = <SddAddressStatus availableStock={availableStock} minimumCaseQty={minimumCaseQty} isLoading={isLoading} address={streetAddress} isAvailable={isDoorDashAvailable} emphasizeAddress={emphasizeAddress} />;
    $[2] = availableStock;
    $[3] = emphasizeAddress;
    $[4] = isDoorDashAvailable;
    $[5] = isLoading;
    $[6] = minimumCaseQty;
    $[7] = streetAddress;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isLoading) {
    t4 = isLoading && <SkeletonBar data-testid="change-store-skeleton" className="delivery-details__change-store-skeleton" />;
    $[9] = isLoading;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isLoading || $[12] !== onOpenAddressDrawer || $[13] !== streetAddress) {
    t5 = !isLoading && <Button type="button" variant="link" className="delivery-details__change-store-btn" text={streetAddress ? "Change" : "Add address"} data-testid="sdd-address-drawer-trigger" onClick={onOpenAddressDrawer} />;
    $[11] = isLoading;
    $[12] = onOpenAddressDrawer;
    $[13] = streetAddress;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="delivery-details__change-store">{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = availableStock > 0 && isDoorDashAvailable;
  let t8;
  if ($[18] !== isLoading || $[19] !== minimumCaseQty || $[20] !== t7) {
    t8 = <SddDeliveryExtras isLoading={isLoading} minimumCaseQty={minimumCaseQty} isDelivery={t7} />;
    $[18] = isLoading;
    $[19] = minimumCaseQty;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t6 || $[25] !== t8) {
    t9 = <div data-testid="sdd-delivery-details" className={t2}>{t3}{t6}{t8}</div>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
type SddAddressStatusProps = Readonly<{
  isLoading: boolean;
  availableStock: number;
  minimumCaseQty: number;
  address?: string;
  isAvailable?: boolean;
  emphasizeAddress: boolean;
}>;
function SddAddressStatus(t0) {
  const $ = _c(18);
  const {
    isLoading,
    address,
    availableStock,
    minimumCaseQty,
    isAvailable: t1,
    emphasizeAddress
  } = t0;
  const isAvailable = t1 === undefined ? true : t1;
  if (isLoading) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <SkeletonBar className="delivery-details__status-skeleton" data-testid="sdd-status-loading" />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (!address) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <TextPassage size="lg" data-testid="sdd-status-no-address">Add an address to check availability</TextPassage>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== availableStock || $[3] !== minimumCaseQty) {
    t2 = validateStockStatus({
      stockQuantity: availableStock,
      minimumCaseQty
    });
    $[2] = availableStock;
    $[3] = minimumCaseQty;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const stockStatus = t2;
  let stockText = "Out of stock";
  if (stockStatus === "InStock") {
    stockText = "Delivering";
  }
  if (stockStatus === "FewLeftInStock") {
    stockText = "Only a few left";
  }
  if (!isAvailable) {
    stockText = "Not available";
  }
  const t3 = stockStatus === "InStock" && isAvailable;
  const t4 = stockStatus !== "InStock" || !isAvailable;
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = cn({
      "sparky-u-color-utility-success": t3,
      "sparky-u-color-utility-error": t4
    });
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = stockText;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="delivery-details__store"> to </span>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = emphasizeAddress && "sparky-u-theme-typography-body-lg-bold";
  let t9;
  if ($[9] !== t8) {
    t9 = cn("delivery-details__store", t8);
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = `${address}`;
  let t11;
  if ($[11] !== t10 || $[12] !== t9) {
    t11 = <span className={t9}>{t10}</span>;
    $[11] = t10;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== stockText || $[15] !== t11 || $[16] !== t5) {
    t12 = <TextPassage size="lg" className={t5} data-testid="sdd-status-content">{t6}{t7}{t11}</TextPassage>;
    $[14] = stockText;
    $[15] = t11;
    $[16] = t5;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}
type SddDeliveryExtrasProps = Readonly<{
  isLoading: boolean;
  minimumCaseQty: number;
  isDelivery: boolean;
}>;
function SddDeliveryExtras(t0) {
  const $ = _c(8);
  const {
    isLoading,
    minimumCaseQty,
    isDelivery
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SkeletonBar className="delivery-details__curbside-skeleton" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== isDelivery) {
    t1 = isDelivery && <TextPassage data-testid="delivery-window-text" className="delivery-details__delivery-window-text">Select a delivery window at checkout</TextPassage>;
    $[1] = isDelivery;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== minimumCaseQty) {
    t2 = <MinimumQuantityText minimumQuantity={minimumCaseQty} />;
    $[3] = minimumCaseQty;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}